// eslint-disable-next-line no-restricted-imports
import { selector as recoilSelector, selectorFamily as recoilSelectorFamily } from "recoil";

/**
 * Recoil's selector and selectorFamily, but each selector keeps only its latest value. Recoil's
 * default keeps every value a selector ever computed, together with the inputs it came from, so a
 * selector over members or jobs held on to every old version of them: with a big company moving all
 * day, the tab grew until Chrome killed it. Import selectors from here, not from "recoil".
 */
const LATEST_ONLY = { eviction: "most-recent" } as const;

// Object.assign keeps the helpers Recoil hangs on these functions (selector.value)
export const selector = Object.assign(
    (options: any) => recoilSelector({ cachePolicy_UNSTABLE: LATEST_ONLY, ...options }),
    recoilSelector,
) as typeof recoilSelector;

export const selectorFamily = Object.assign(
    (options: any) => recoilSelectorFamily({ cachePolicy_UNSTABLE: LATEST_ONLY, ...options }),
    recoilSelectorFamily,
) as typeof recoilSelectorFamily;
